import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../PasswordProtectionUnlock.module.scss';
import { PublicImage } from '@/components/common/PublicImage/PublicImage';
import {
  Button,
  EButtonHierarchy,
  EButtonSize,
} from '@/components/common/Button/Button';

interface IForgotPasswordSuccessViewProps {
  readonly email: string | null;
  readonly onClose: () => void;
}

export const ForgotPasswordSuccessView: React.FC<
  IForgotPasswordSuccessViewProps
> = ({ email, onClose }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.forgotPasswordSuccessWrapper}>
      <PublicImage
        className={styles.forgotPasswordSuccessImg}
        src="/images/misc/reset-password-success.png"
        alt="reset-password-success"
      />
      <div className={styles.forgotPasswordSuccessTitle}>
        {t('blockPage.unlock.resetPasswordSuccessTitle')}
      </div>
      <div className={styles.forgotPasswordSuccessDescription}>
        {t('blockPage.unlock.resetPasswordSuccessDescription', {
          email: email ?? '',
        })}
      </div>
      <Button
        fillWidth={true}
        onClick={onClose}
        hierarchy={EButtonHierarchy.primary}
        size={EButtonSize.lg}
        text="blockPage.unlock.resetPasswordSuccessOk"
      />
    </div>
  );
};
